import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';

const propTypes = {
  columnsToDisplay: PropTypes.array.isRequired,
  dataRowsToDisplay: PropTypes.array.isRequired,
  isTableSelectable: PropTypes.bool.isRequired,

  // This is the column keys which we align the reduce results below.
  // It may not be the column keys to reduce, e.g. totalHoursString vs totalHours.
  columnKeysToAlign: PropTypes.array.isRequired,
  reducers: PropTypes.array.isRequired,
  formatters: PropTypes.array.isRequired,
};

@autobind
class TfootSummary extends BaseComponent {
  constructor(props) {
    super(props);
  }

  /* PUBLIC */
  static SUM_REDUCER_GENERATOR(columnKeyToReduce) {
    return (accumulator, currentRow) => accumulator + (currentRow[columnKeyToReduce] || 0);
  }

  /* PUBLIC */
  /* The key difference between this and SUM_REDUCER_GENERATOR is that, it will fix the
   * in-precision caused by floating point representation (Refer to helpers.toDollars()
   * for more details.) before rounding to 2 decimal places and perform addition.
   */
  static SUM_DOLLAR_REDUCER_GENERATOR(columnKeyToReduce) {
    return (accumulator, currentRow) => {
      const amountRounded = Number(((currentRow[columnKeyToReduce] || 0) + 0.00000001).toFixed(2));
      return accumulator + amountRounded;
    };
  }

  createColSpanColumn() {
    const { columnsToDisplay, isTableSelectable, columnKeysToAlign } = this.props;

    const index = columnsToDisplay.findIndex(c => columnKeysToAlign.includes(c.dataIndex));
    return (
      <th
        colSpan={`${(index >= 0 ? index : columnsToDisplay.length) + (isTableSelectable ? 1 : 0)}`}
        style={{ textAlign: 'right' }}
      >
        Total:
      </th>
    );
  }

  createReducedColumns() {
    const {
      columnsToDisplay,
      dataRowsToDisplay,
      columnKeysToAlign,
      reducers,
      formatters,
    } = this.props;
    const reducedColumns = [];

    const firstIndex = columnsToDisplay.findIndex(c => columnKeysToAlign.includes(c.dataIndex));
    if (firstIndex >= 0) {
      for (let i = firstIndex; i < columnsToDisplay.length; i++) {
        const colIndex = columnKeysToAlign.indexOf(columnsToDisplay[i].dataIndex);
        const result = colIndex >= 0 ? dataRowsToDisplay.reduce(reducers[colIndex], 0) : null;
        reducedColumns.push(<th key={i}>{`${colIndex >= 0 ? formatters[colIndex](result) : ''}`}</th>);
      }
    }
    return reducedColumns;
  }

  renderContent() {
    return (
      <tfoot>
        <tr>
          {this.createColSpanColumn()}
          {this.createReducedColumns()}
        </tr>
      </tfoot>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
TfootSummary.propTypes = propTypes;

export default TfootSummary;
